import { render, staticRenderFns } from "./OpticalCrossImage.vue?vue&type=template&id=5190b3d5&scoped=true&"
import script from "./OpticalCrossImage.vue?vue&type=script&lang=js&"
export * from "./OpticalCrossImage.vue?vue&type=script&lang=js&"
import style0 from "./OpticalCrossImage.vue?vue&type=style&index=0&id=5190b3d5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5190b3d5",
  null
  
)

export default component.exports